import React from 'react';

import { Lock1, Unlock, Calendar } from 'iconsax-react';

import { hexToRgba } from 'utils/colorUtils';

import classes from './ToolkitBanner.module.scss';

const ToolkitBanner = ({ toolkit }) => {
    const categoryColor = toolkit?.category?.color || '#BB3A90';

    return (
        <div
            className={classes['banner']}
            style={{
                background: `linear-gradient(270deg, ${hexToRgba(categoryColor, 0.24)} -1.67%, #FFF 38.21%)`,
            }}
        >
            <div className={`container ${classes['banner-inner']}`}>
            <div className={classes['content']}>
                <h1>{toolkit?.name}</h1>
                <p>{toolkit?.description}</p>
                <div className={classes['meta']}>
                    {toolkit?.has_access ? (
                        <span className={`${classes['badge']} ${classes['unlocked']}`}>
                            <Unlock size={14} />
                            Unlocked
                        </span>
                    ) : (
                        <span className={`${classes['badge']} ${classes['locked']}`}>
                            <Lock1 size={14} />
                            Locked
                        </span>
                    )}
                    {toolkit?.file_updated_at && (
                        <span className={`${classes['badge']} ${classes['updated']}`}>
                            <Calendar size={14} />
                            Updated {toolkit.file_updated_at}
                        </span>
                    )}
                </div>
            </div>
            <div className={classes['icon-wrapper']}>
                {toolkit?.category?.logo && (
                    <div
                        className={classes['icon']}
                    >
                        <img src={toolkit.category.logo} alt={toolkit?.category?.name || ''} />
                    </div>
                )}
                {toolkit?.category?.name && (
                    <span
                        className={classes['category-label']}
                        style={{
                            backgroundColor: hexToRgba(categoryColor, 0.12),
                            color: categoryColor,
                        }}
                    >
                        {toolkit.category.name}
                    </span>
                )}
            </div>
            </div>
        </div>
    );
};

export default ToolkitBanner;
